import React from 'react';
import styled from 'styled-components';
import { LinkOutlined, DeleteOutlined } from '@ant-design/icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Container = styled.div.withConfig({
  displayName: "url-itemcomponent__Container",
  componentId: "sc-2corls-0"
})(["display:flex;align-items:center;gap:12px;padding:12px;background:#ffffff;border:1px solid #f0f2f7;border-radius:12px;box-shadow:0 1px 2px rgba(0,0,0,0.03);&:hover{border-color:#e0e4ef;}"]);
var IconWrapper = styled.div.withConfig({
  displayName: "url-itemcomponent__IconWrapper",
  componentId: "sc-2corls-1"
})(["display:flex;align-items:center;justify-content:center;width:32px;height:32px;border-radius:8px;background:#eff6ff;color:#3b82f6;flex-shrink:0;"]);
var UrlText = styled.div.withConfig({
  displayName: "url-itemcomponent__UrlText",
  componentId: "sc-2corls-2"
})(["flex:1;font-size:14px;color:#1a2140;word-break:break-all;line-height:1.5;"]);
var RemoveButton = styled.button.withConfig({
  displayName: "url-itemcomponent__RemoveButton",
  componentId: "sc-2corls-3"
})(["display:flex;align-items:center;justify-content:center;width:28px;height:28px;border:none;background:transparent;color:#9aa4c2;cursor:pointer;border-radius:6px;transition:all 0.2s;flex-shrink:0;&:hover{color:#ef4444;background:#fef2f2;}"]);
export var UrlItem = function UrlItem(_ref) {
  var url = _ref.url,
      onRemove = _ref.onRemove;
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsx(IconWrapper, {
      children: /*#__PURE__*/_jsx(LinkOutlined, {
        style: {
          fontSize: 16
        }
      })
    }), /*#__PURE__*/_jsx(UrlText, {
      children: url
    }), /*#__PURE__*/_jsx(RemoveButton, {
      onClick: onRemove,
      type: "button",
      children: /*#__PURE__*/_jsx(DeleteOutlined, {
        style: {
          fontSize: 16
        }
      })
    })]
  });
};